module.exports = __webpack_public_path__ + "static/media/sidebar-3.cd253e23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar-3.jpg
// module id = 789
// module chunks = 0